import { useEffect, useState } from "react";
import api from "@/lib/api";
import ContractsHome from "./contracts/ContractsHome";
import NewContract from "./contracts/NewContract";
import InterviewWizard from "./contracts/InterviewWizard";
import ContractEditor from "./contracts/ContractEditor";

export default function Contracts() {
  const [mode, setMode] = useState("home"); // home | new | interview | editor
  const [type, setType] = useState(null);
  const [contractId, setContractId] = useState(null);
  const [canDocx, setCanDocx] = useState(true);

  useEffect(() => { api.get("/contracts/catalog").then(({ data }) => setCanDocx(!!data.features?.docx)).catch(() => {}); }, []);

  const openEditor = (id) => { setContractId(id); setMode("editor"); };

  return (
    <div>
      {mode === "home" && <ContractsHome onNew={() => setMode("new")} onOpen={openEditor} />}
      {mode === "new" && <NewContract onBack={() => setMode("home")} onPick={(t) => { setType(t); setMode("interview"); }} />}
      {mode === "interview" && type && (
        <InterviewWizard type={type} onBack={() => setMode("new")} onCreated={(c) => openEditor(c.contract_id)} />
      )}
      {mode === "editor" && contractId && (
        <ContractEditor key={contractId} contractId={contractId} canDocx={canDocx}
          onBack={(c) => { if (c && c.contract_id) { setContractId(c.contract_id); } else { setMode("home"); } }}
          onChanged={() => {}} />
      )}
    </div>
  );
}
